import React, { useState } from 'react';
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { useForm } from 'react-hook-form'

import { Form ,Button} from 'react-bootstrap';

import RequestManager from "../../singletons/RequestManager";





export default function AddDeliverySlotDetails(props){
  console.log(props)
  
    
  const stime = {'00:00':'12:00 AM',
  '00:30':'12:30 AM',
  '01:00':'01:00 AM',
  '01:30':'01:30 AM',
  '02:00':'02:00 AM',
  '02:30':'02:30 AM',
  '03:00':'03:00 AM',
  '03:30':'03:30 AM',
  '04:00':'04:00 AM',
  '04:30':'04:30 AM',
  '05:00':'05:00 AM',
  '05:30':'05:30 AM',
  '06:00':'06:00 AM',
  '06:30':'06:30 AM',
  '07:00':'07:00 AM',
  '07:30':'07:30 AM',
  '08:00':'08:00 AM',
  '08:30':'08:30 AM',
  '09:00':'09:00 AM',
  '09:30':'09:30 AM',
  '10:00':'10:00 AM',
  '10:30':'10:30 AM',
  '11:00':'11:00 AM',
  '11:30':'11:30 AM',
  '12:00':'12:00 PM',
  '12:30':'12:30 PM',
  '13:00':'01:00 PM',
  '13:30':'01:30 PM',
  '14:00':'02:00 PM',
  '14:30':'02:30 PM',
  '15:00':'03:00 PM',
  '15:30':'03:30 PM',
  '16:00':'04:00 PM',
  '16:30':'04:30 PM',
  '17:00':'05:00 PM',
  '17:30':'05:30 PM',
  '18:00':'06:00 PM',
  '18:30':'06:30 PM',
  '19:00':'07:00 PM',
  '19:30':'07:30 PM',
  '20:00':'08:00 PM',
  '20:30':'08:30 PM',
  '21:00':'09:00 PM',
  '21:30':'09:30 PM',
  '22:00':'10:00 PM',
  '22:30':'10:30 PM',
  '23:00':'11:00 PM',
  '23:30':'11:30 PM'}  

 

  const [displaymesg, setDisplaymesg] = useState();
  const [modal, setModal] = useState(false);
  const [onDemandDelivery, setOnDemandDelivery] = useState(true)
  const [vdeliveryDuration, setvDeliveryDuration] = useState(60)
  const toggle = () => setModal(!modal);
  const {register,handleSubmit,errors,setError} = useForm();
  React.useEffect(() => {
  }, []);

  let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

//   console.log(storeInformation.store.id,"sdlksj")

  const handlechange = (event) =>{
    console.log('onhandlechange', event.target.value)
    if (event.target.value == 'ONDEMAND'){
      setOnDemandDelivery(true);
    }else{
      setOnDemandDelivery(false);
    }

  }
  const handledurationchange = (event) =>{
    console.log('onhandlechange', event.target.value)
    switch(event.target.value) {
      case '30 Mins':
        setvDeliveryDuration(30);
        console.log('onhandlechangedetail', 30);
        break
      case '45 Mins':
        setvDeliveryDuration(45);
        console.log('onhandlechangedetail', 45);
        break
      case '1 Hour':
        setvDeliveryDuration(60);
        console.log('onhandlechangedetail', 60);
        break
      case '2 Hours':
        setvDeliveryDuration(120);
        console.log('onhandlechangedetail', 120);
        break
      case '3 Hours':
        setvDeliveryDuration(180);
        console.log('onhandlechangedetail', 180);
        break
      case '4 Hours':
        setvDeliveryDuration(240);
        console.log('onhandlechangedetail', 240);
        break
    }

  }

 async function onSubmit(values) {
    let requestManager = new RequestManager();
    let params;
    console.log(values,"orderslotdetails")
    
    if(onDemandDelivery == true){
      if (vdeliveryDuration == null ){
        setDisplaymesg("Select Delivery Duration")
        return
      }
      params ={
      input: {
        store: values.storeId,
        deliveryType: values.DeliveryType,
        deliveryduration:vdeliveryDuration,
        status:values.Status
        }
      }  
    }else{
      if (values.Capacity == '' || values.Capacity == undefined){
        setDisplaymesg("Missing Required Fields")
        return
      }
      if (values.StartTime == values.EndTime){
        setDisplaymesg("Enter Valid End Time")
        return
      }
      params ={
        input: {
          store: values.storeId,
          deliveryType: values.DeliveryType,
          startTime: values.StartTime,
          endTime:values.EndTime,
          orderCutoff:values.OrderCutoff,
          capacity:parseInt(values.Capacity),
          status:values.Status
        }
      }    
    }

   
  let response =await requestManager.getResponseFromPredefinedQuery(
      "updateStoreDeliverySlot",
      params
  );

    console.log(response,"response")
    if (response.data.updateStoreDeliverySlot.success == true){
      setDisplaymesg("Succesfully added")
      window.location.reload(false);
    }else
    {
      setDisplaymesg("Somthing went wrong, please try again")
    }
   
}
 
  return (
    <div>
     <Button color="success" style={{width:'95%'}} onClick={toggle}>Add</Button>
      <Modal isOpen={modal} toggle={toggle} className="">
      {displaymesg &&
     <div className="alert alert-success">
     <strong>{displaymesg}!</strong> 
     </div>
           }
        <ModalHeader toggle={toggle}>Store Delivery Slot</ModalHeader>
        <ModalBody>

              {errors.DeliveryType && <p className="alert alert-danger aswm" >{errors.DeliveryType.message}</p>}
              {errors.StartTime && <p className="alert alert-danger aswm" >{errors.StartTime.message}</p>}
              {errors.EndTime && <p className="alert alert-danger aswm" >{errors.EndTime.message}</p>}
              {/*errors.DeliveryDuration && <p className="alert alert-danger aswm" >{errors.DeliveryDuration.message}</p>*/}
              {errors.OrderCutoff && <p className="alert alert-danger aswm" >{errors.OrderCutoff.message}</p>}

        <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Control type="text" name="storeId" hidden id="storeId" defaultValue={storeInformation.store.id}   ref={register} />

  <Form.Group >
    <Form.Label >Delivery Type</Form.Label>
    <Form.Control as="select" name="DeliveryType" id="DeliveryType"  onChange={handlechange} ref={register}>
      <option>ONDEMAND</option>
      <option>SAMEDAY</option>
      <option>NEXTDAY</option>
    </Form.Control>
  </Form.Group>

  <Form.Group >
    <Form.Control type="text" name="Status" id="Status" hidden defaultValue="ACTIVE"   ref={register} />
  </Form.Group>
  {!onDemandDelivery && (
    <div>
  <Form.Group>
    <Form.Label>Start Time</Form.Label>
    <Form.Control as="select" name="StartTime" id="StartTime" ref={register}>
     {Object.entries(stime).map((key, value) => (
          <option id={key[1]} >{key[0]}</option>
      ))}
    </Form.Control>
  </Form.Group>
  
  <Form.Group>
    <Form.Label>End Time</Form.Label>
    <Form.Control as="select" name="EndTime" id="EndTime"  ref={register}>
     {Object.entries(stime).map((key, value) => (
          <option id={key[1]} >{key[0]}</option>
      ))}
    </Form.Control>
  </Form.Group>
  
  <Form.Group>
    <Form.Label>Capacity</Form.Label>
    <Form.Control type="number" name="Capacity" id="Capacity" ref={register} />
  </Form.Group>

  <Form.Group>
    <Form.Label>Order Cutoff</Form.Label>
    <Form.Control as="select" name="OrderCutoff" id="OrderCutoff"  ref={register}>
     {Object.entries(stime).map((key, value) => (
          <option id={key[1]} >{key[0]}</option>
      ))}
    </Form.Control>
  </Form.Group>
  </div>
  )}
  {onDemandDelivery && (
  <Form.Group>
    <Form.Label>Duration</Form.Label>
    <select style={{width:"95%"}} defaultValue={'1 Hour'} onChange={handledurationchange}>
            <option id={30}>30 Mins</option>
            <option id={45}>45 Mins</option>
            <option id={60}>1 Hour</option>
            <option id={120}>2 Hours</option>
            <option id={180}>3 Hours</option>
            <option id={240}>4 Hours</option>  
    </select>
  </Form.Group>
)}
  <ModalFooter>
  <Button type="submit" style={{background:"green"}} color="primary">Submit</Button>{' '}
  <Button color="secondary"  style={{background:"red"}} onClick={toggle}>Cancel</Button>
</ModalFooter>
</Form>
</ModalBody>
</Modal>
    </div>
  );
}









// WEBPACK FOOTER //
// ./src/components/DeliverySlots/AddDeliverySlotDetails.js